import { ElementType } from 'react'

import { Box, Stack, Typography } from '@mui/material'

import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  iconContentSx,
  iconSx,
  iconWrapperSx,
  subtitleSx,
  textWrapperSx,
  titleSx,
} from './styles'

interface IItemProps {
  title: string
  subtitle: string
  variant: 'white' | 'blue'
  icon: ElementType
}

const Item = ({ title, subtitle, icon: Icon, variant }: IItemProps) => (
  <Stack direction="row" sx={containerSx}>
    <Stack sx={iconContentSx}>
      <Box sx={iconWrapperSx({ variant })}>
        <Icon sx={iconSx({ variant })} />
      </Box>
    </Stack>

    <Stack sx={textWrapperSx}>
      <TLGTypography responsiveVariant={{ xs: 'h6', lg: 'h5' }} sx={titleSx}>
        {title}
      </TLGTypography>
      <Typography sx={subtitleSx}>{subtitle}</Typography>
    </Stack>
  </Stack>
)

export { Item }
